// src/Api/baseapi.js
import axios from "axios";
import { toast } from "react-toastify";

// If you have token logic, keep it. Otherwise remove it.
const BASE = "https://d360-backend.vercel.app/api";

const baseapi = axios.create({
  baseURL: BASE,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

// Optional: attach token if exists
baseapi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global error handling
baseapi.interceptors.response.use(
  (res) => res,
  (err) => {
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong";
    toast.error(msg);
    return Promise.reject(err);
  }
);

export default baseapi;
